import { getApiUrlWithDynamicDomain } from '@/utils/getApiUrlWithDynamicDomain'

import type { Mode } from '@/types/environment'

import { $fetch } from 'ofetch'

export const useCustomFetch = (version: number) => {
  const { $host } = useNuxtApp()
  const { API_BASE_URL, MODE, BRAND_UUID } = useRuntimeConfig().public

  const API_URL = getApiUrlWithDynamicDomain(
    API_BASE_URL as string,
    $host,
    MODE as Mode,
  )

  return $fetch.create({
    baseURL: `${API_URL}/v${version}/${BRAND_UUID}`,
  })
}
